export enum GroupType {
    VIEW = "VIEW",
    WELL_LOG_TRACK_CONT = "WELL_LOG_TRACK_CONTINUOUS",
    WELL_LOG_TRACK_DISC = "WELL_LOG_TRACK_DISCRETE",
    WELL_LOG_DIFF_GROUP = "WELL_LOG_DIFF_GROUP",
    INTERSECTION_VIEW = "INTERSECTION_VIEW",
}
